import React from 'react';
import { Icon } from 'components/Icon';
import { dateTimeFormat } from 'constants/date-format';
import moment from 'moment';
import { PhaseResult } from 'pages/user-test/store';
import { useTranslation } from 'react-i18next';

interface PhasesListProps {
    phases: PhaseResult[];
    showDetails?: boolean;
}

export const PhasesList = (props: PhasesListProps) => {
    const { phases, showDetails } = props;
    const [t] = useTranslation(['user-test']);

    return (
        <>
            {!phases || phases.length === 0 ? (
                <p>Empty</p>
            ) : (
                <ol className="phase-result-container">
                    {t('need-to-get-approve')}
                    {phases?.map((phase) => (
                        <li className="phase-result-item" key={phase.id}>
                            <div className="phase-result-item-row">
                                {phase.accepted ? (
                                    <Icon key="check-mark-2" iconName="check-mark-2" />
                                ) : (
                                    <Icon key="close" iconName="close" />
                                )}
                                {phase.description}
                            </div>

                            {phase?.passingTestPhaseAcceptedList?.length !== 0 && showDetails && (
                                <ul className="phase-result-container">
                                    {phase.passingTestPhaseAcceptedList.map((i) => (
                                        <li key={i.id} className="phase-result-item">
                                            <div className="phase-result-item-row">
                                                {i.accepted ? (
                                                    <Icon key="check-mark-2" iconName="check-mark-2" />
                                                ) : (
                                                    <Icon key="close" iconName="close" />
                                                )}
                                                {moment(i.creationDate).format(dateTimeFormat)}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </>
    );
};
